import { CronExpressionParser } from 'cron-parser'

/**
 * Compute the next firing time for a cron expression.
 *
 * Returns `null` when the expression cannot be parsed — callers render that
 * as "Invalid cron expression" or hide the preview entirely.
 *
 * cron-parser v5 exports `CronExpressionParser` (the older `parseExpression`
 * named export was removed in the v4 → v5 break). Timezone is pinned to UTC
 * via the `tz` option so previews match the cron scheduler's runtime, which
 * also runs in UTC.
 */
export function nextCronRun(
  cronExpression: string,
  now: Date = new Date(),
): Date | null {
  try {
    const interval = CronExpressionParser.parse(cronExpression, {
      currentDate: now,
      tz: 'UTC',
    })
    return interval.next().toDate()
  } catch {
    return null
  }
}

/**
 * Format the next firing time as "YYYY-MM-DD HH:mm UTC". Returns
 * "Invalid cron expression" when the cron string cannot be parsed.
 */
export function formatNextRun(
  cronExpression: string,
  now: Date = new Date(),
): string {
  const next = nextCronRun(cronExpression, now)
  if (!next) return 'Invalid cron expression'
  return next.toISOString().replace('T', ' ').slice(0, 16) + ' UTC'
}
